import { useEffect, useRef, useState } from "react";
// import { useTopicContext } from "../hooks/useContext/useTopicContext";
import { useAuthContext } from "../hooks/useContext/useAuthContext";
// import { useActiveTopicContext } from "../hooks/useContext/useActiveTopicContext";
import { useAllOrdersContext } from "../hooks/useContext/useAllOrdersContext";
// import TopicDetails from "../components/Dashboard_Page/topicDetails"
import OrdersComponentController from "../components/Dashboard_Page/OrdersComponentController";
import { PendingOrdersAmount } from "../components/Dashboard_Page/PendingOrdersAmount";
import { OrdersAmountToday } from "../components/Dashboard_Page/OrdersAmountToday";
import { OrdersAmountWeek } from "../components/Dashboard_Page/OrdersAmountWeek";
import DashboardNavBar from "../components/NavBar/DashboardNavBar";
import Footer from "../components/Shared/Footer";
import { Grid }  from "@mui/material";
import { styled } from "@mui/system";
import { OpenStatus } from "../components/Dashboard_Page/OpenStatus";
import { useTheme } from "@mui/material/styles";

const GridContainerMain = styled(Grid)(({ theme }) => ({
  paddingLeft: "24px",
  paddingRight: "24px",
  paddingTop: "30px",
  backgroundColor: theme.palette.common.background,
  paddingBottom: "50px",
}));

const DashboardContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  backgroundColor: theme.palette.common.background,// Ensure the container takes at least the viewport height
}));

const ContentContainer = styled('div')({
  flex: 1, // Makes this container grow and fill the space
});

const Dashboard = ({socket}) => {
  const { allOrders, allOrdersDispatch } = useAllOrdersContext();
  const { user } = useAuthContext();
  const theme = useTheme();
  const audioRef = useRef(null);
  const audioUnlockedRef = useRef(false);
  const [ordersTab, setOrdersTab] = useState('pending');
  const ordersSectionRef = useRef(null);

  const openPendingOrdersTab = () => {
    setOrdersTab('pending');
    if (ordersSectionRef.current && typeof ordersSectionRef.current.scrollIntoView === 'function') {
      ordersSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const openAllOrdersTab = () => {
    setOrdersTab('all');
    if (ordersSectionRef.current && typeof ordersSectionRef.current.scrollIntoView === 'function') {
      ordersSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Initialize and unlock audio on first user interaction
  useEffect(() => {
    // Preload audio
    audioRef.current = new Audio('/sounds/chaching.mp3');
    audioRef.current.volume = 1.0;
    audioRef.current.load();

    const unlockAudio = () => {
      if (!audioUnlockedRef.current && audioRef.current) {
        // Play and immediately pause to unlock audio context
        audioRef.current.play().then(() => {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          audioUnlockedRef.current = true;
          console.log("Audio unlocked successfully");
        }).catch((err) => {
          console.log("Audio unlock failed:", err);
        });
      }
    };

    // Unlock on first click, touch, or keypress
    document.addEventListener('click', unlockAudio, { once: true });
    document.addEventListener('touchstart', unlockAudio, { once: true });
    document.addEventListener('keydown', unlockAudio, { once: true });

    return () => {
      document.removeEventListener('click', unlockAudio);
      document.removeEventListener('touchstart', unlockAudio);
      document.removeEventListener('keydown', unlockAudio);
    };
  }, []);


  //fetch topics on socket event
  useEffect(() => {
    const fetchOrders = async () => {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + "/api/orders/", {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      const json = await response.json();
      if (response.ok) {
        allOrdersDispatch({ type: "SET_ALL_ORDERS", payload: json });
      } else {
        window.location.reload();
      };
    };
    //data is the returning url from server
    const handleTopicId = (data) => {
      fetchOrders();
      console.log(`Received order._id: ${data}`);
      
      // Play sound notification using the preloaded audio
      if (audioRef.current) {
        audioRef.current.currentTime = 0; // Reset to start
        const playPromise = audioRef.current.play();
        
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log("Sound played successfully");
            })
            .catch((error) => {
              console.error("Failed to play sound:", error);
              console.log("Make sure you've clicked on the page at least once to enable sounds.");
            });
        }
      }
    };
    
    if (socket) {
      socket.on('newOrder', handleTopicId);
    }
    
    return () => {
      if (socket) {
        socket.off('newOrder', handleTopicId);
      }
    };
  }, [user, allOrdersDispatch, socket]);


  //fetch user configs on initial render
  useEffect(() => {
    const fetchAllOrders = async () => {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + "/api/orders/", {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      const json = await response.json();
      if (response.ok) {
        allOrdersDispatch({ type: "SET_ALL_ORDERS", payload: json });
      }
    };
   
    if (user) {
      fetchAllOrders();
    } 
    else {
      localStorage.removeItem("user");
    }
  }, [allOrdersDispatch, user]);


// console.log(allOrders);
  return (
    <div style={{backgroundColor: theme.palette.common.background}}>
     <DashboardContainer>
      <DashboardNavBar />
      <ContentContainer>
        <GridContainerMain container spacing={3} sx={{paddingBottom: {xs: "50px", sm: "50px", md: "50px", lg: "50px", xl: "150px"}}}>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container spacing={{xs:3, sm:3, md:3, lg:4, xl:6}}>
              <Grid item xs={12} sm={6} md={6} lg={3.3} xl={3.3} >
                <PendingOrdersAmount allOrders={allOrders || []} onClick={openPendingOrdersTab} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3.3} xl={3.3} >
                <OrdersAmountToday allOrders={allOrders || []} onClick={openAllOrdersTab} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3.3} xl={3.3} >
                <OrdersAmountWeek allOrders={allOrders || []} />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={2.1} xl={2} >
                <OpenStatus />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div ref={ordersSectionRef}>
              <OrdersComponentController tabValue={ordersTab} onTabChange={setOrdersTab} />
            </div>
          </Grid>
        </GridContainerMain>
      </ContentContainer>

      <Footer />
    </DashboardContainer>
    </div>
  );
};

export default Dashboard;